import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import DeviceIcon from '@blade/common/components/map-doms/device/index.vue';
import { EDeviceStatus } from '@blade/common/components/map-doms/device/interfaces/index';
import colors from '@/styles/color.scss';
let default_1 = class extends Vue {
    deviceSortID = 0;
    isLoop = false;
    duration = 300;
    isShowHover = false;
    devices = [
        {
            id: 'changeDeviceId',
            name: '设备2',
            status: EDeviceStatus.ABNORMAL,
            isShowAnimation: true,
        },
        {
            id: '1',
            name: '在线设备1',
            status: EDeviceStatus.ONLINE,
            isShowAnimation: true,
        },
        {
            id: '2',
            name: '异常设备2',
            status: EDeviceStatus.ABNORMAL,
        },
        {
            id: '3',
            name: '离线设备3',
            status: EDeviceStatus.OFFLINE,
        },
        {
            id: '4',
            name: '未知设备4',
            status: EDeviceStatus.UNUSUAL,
        },
        {
            id: '5',
            name: '地图管理在线设备5',
            status: EDeviceStatus.ONLINE,
            scene: 'manage',
        },
        {
            id: '6',
            name: '地图管理在线设备aiot',
            status: EDeviceStatus.ONLINE,
            scene: 'aiot',
        },
        {
            id: '7',
            name: '地图管理离线设备aiot',
            status: EDeviceStatus.OFFLINE,
            scene: 'aiot',
        },
        {
            id: '8',
            name: '地图管理在线设备its',
            status: EDeviceStatus.ONLINE,
            scene: 'its',
        },
        {
            id: '9',
            name: '地图管理离线设备its',
            status: EDeviceStatus.OFFLINE,
            scene: 'its',
        },
        {
            id: '10',
            name: '地图管理异常设备its',
            status: EDeviceStatus.ABNORMAL,
            scene: 'its',
        },
    ];
    stepsConfig = {
        [EDeviceStatus.ABNORMAL]: {
            0: {
                width: 0,
                color: colors.deviceAbnormalShadow,
            },
            0.5: {
                width: 7,
                color: colors.deviceAbnormalShadow,
            },
            1: {
                width: 14,
                color: colors.deviceAbnormalShadow,
            },
        },
        [EDeviceStatus.ONLINE]: {
            0: {
                width: 0,
                color: colors.deviceOnlineShadow,
            },
            0.5: {
                width: 7,
                color: colors.deviceOnlineShadow,
            },
            1: {
                width: 14,
                color: colors.deviceOnlineShadow,
            },
        },
    };
    changeStatus(type) {
        if (type === 'loop') {
            this.isLoop = !this.isLoop;
        }
        else {
            this.devices[0].status = this.devices[0].status === 'ABNORMAL' ? 'ONLINE' : 'ABNORMAL';
        }
        if (type === 'isShowHover') {
            this.isShowHover = !this.isShowHover;
        }
    }
    addDevice(type) {
        const id = this.deviceSortID++;
        this.devices.push({
            id: 'add' + id,
            name: '新增设备' + id,
            status: type,
            scene: 'manage',
            isShowAnimation: true,
        });
    }
};
default_1 = __decorate([
    Component({
        name: 'testpage',
        components: { DeviceIcon },
    })
], default_1);
export default default_1;
